var map = {
	"./Htl_Verdes.png": 91658,
	"./favicon.ico": 10492,
	"./logo-full.png": 60183,
	"./logo-full.svg": 73080,
	"./logo-itinerary.png": 24189,
	"./logo-voucher.png": 84680,
	"./logo-voucher.svg": 48487,
	"./logo-white.png": 53529,
	"./logo-white.svg": 41486,
	"./logo.png": 85469,
	"./logo.svg": 37186
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 42635;
module.exports = webpackAsyncContext;